/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.directive('userLogin', () => ({
    restrict: 'E',
    replace:  true,
    controller: 'UserLoginCtrl',
    template: '<span ng-bind="user_display"></span>',

    scope: {
        user_id: '=userId'
    }
}));
